import useInterval from './useInterval'
import formatNumber from './formatNumber'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
  
export { classNames, useInterval, formatNumber }